jQuery(document).ready(function($) {
  jQuery('.promo_popup').css('cssText', "transform: translateX(0%);");

  jQuery('.promo_popup').click(function() {
      jQuery('.promo_popup').hide();
  });


});

jQuery('.rb-multi-step').ready(function($) {


    var otp_selected = false;

    //setTimeout(function() {
    var set_interval_id = false;
    set_interval_id = setInterval(function() {

        
        // check if subscription or otp
        per_smoothie = jQuery(".rb-price .rb-full-price").text();
        

        if(per_smoothie == "")
        {
          per_smoothie = jQuery(".rb-price span").text();
        }

        if(per_smoothie != "loading..." && per_smoothie != "")
        {
          // kill interval timer
          clearInterval(set_interval_id);          

            //
            // INIT
            //

            jQuery(".the_smoothie_box .rb-nav-wrapper").after('<div class="per_smoothie_price"></div>');

            var per_smoothie = jQuery(".rb-option--selected .rb-option-details").text();

            
            // check
            if (per_smoothie != "") {
                if(otp_selected == false)
                {
                    jQuery(".per_smoothie_price").text(per_smoothie);
                }
                else
                {
                    per_smoothie = per_smoothie.replace("$", "");
                    per_smoothie = per_smoothie.replace("USD ", "");

                    if (per_smoothie == "175.76") {
                        // otp
                        per_smoothie = "$2.93 per Smoothie";

                    } else if (per_smoothie == "126.59") {
                        // otp
                        per_smoothie = "$3.17 per Smoothie";

                    } else if (per_smoothie == "84.42") {
                        // otp
                        per_smoothie = "$3.52 per Smoothie";
                    }
                }
            } else {
                // hide price_per_smoothie, blank data
                jQuery('.per_smoothie_price').hide();
                console.log("error, hiding per_smooothier_price");
            }



            // smoothie box option click
            jQuery(".rb-option").click(function() {
                var per_smoothie = jQuery(this).find(".rb-option-details").text();


                // check
                if (per_smoothie != "") {
                    if(otp_selected == false)
                    {
                        jQuery(".per_smoothie_price").text(per_smoothie);
                    }
                    else
                    {

                        if (per_smoothie == "$2.49 per Smoothie") {
                            // otp
                            per_smoothie = "$2.93 per Smoothie";

                        } else if (per_smoothie == "$2.69 per Smoothie") {
                            // otp
                            per_smoothie = "$3.17 per Smoothie";

                        } else if (per_smoothie == "$2.99 per Smoothie") {
                            // otp
                            per_smoothie = "$3.52 per Smoothie";
                        }
                        jQuery(".per_smoothie_price").text(per_smoothie);
                    }
                } else {
                    // hide price_per_smoothie, blank data
                    jQuery('.per_smoothie_price').hide();

                }
            });


            //
            // BOTTOM NEXT BUTTON
            //
            jQuery(".rb-footer-actions .rb-btn").click(function() {
                //clean titles
                $(".rb-item-content").each(function() {
                    // get element text
                    var text = $(this).find(".rb-title").text();

                    // modify text
                    text = text.replace("Bag FS", "");
                    text = text.replace("Jar (Bundles)", "");
                    text = text.replace("Powder", "");

                    // update element text
                    $(this).find(".rb-title").text(text);
                });

                // subscribe text
                var subscribe_text = jQuery(".rb-frequency-label span").first().text();

                if (subscribe_text == "Subscribe") {
                    jQuery(".rb-frequency-label span").first().text("Subscribe & Save 15%");
                }

                jQuery('.rb-qty-wrapper .rb-input').attr('disabled', 'disabled');
            });



            //
            // TOP NEXT BUTTON
            //
            jQuery(".rb-price-btn-wrapper .rb-btn").click(function() {
                //clean titles
                $(".rb-item-content").each(function() {
                    // get element text
                    var text = $(this).find(".rb-title").text();

                    // modify text
                    text = text.replace("Bag FS", "");
                    text = text.replace("Jar (Bundles)", "");
                    text = text.replace("Powder", "");

                    // update element text
                    $(this).find(".rb-title").text(text);

                });

                // subscribe text
                var subscribe_text = jQuery(".rb-frequency-label span").first().text();

                if (subscribe_text == "Subscribe") {
                    jQuery(".rb-frequency-label span").first().text("Subscribe & Save 15%");
                }


                if (jQuery('.the_smoothie_box .rb-step-title').text() == "Your Smoothie Box Details") {
                    // smoothie bundle freq change
                    jQuery('.the_smoothie_box .rb-frequency').click(function() {
                        var per_smoothie = jQuery(this).find(".rb-frequency-price").text();

                        per_smoothie = per_smoothie.replace("$", "");
                        per_smoothie = per_smoothie.replace("USD ", "");

                        if (per_smoothie == "175.76") {
                            // otp
                            per_smoothie = "$2.93 per Smoothie";
                            otp_selected = true;

                        } else if (per_smoothie == "126.59") {
                            // otp
                            per_smoothie = "$3.17 per Smoothie";
                            otp_selected = true;

                        } else if (per_smoothie == "84.42") {
                            // otp
                            per_smoothie = "$3.52 per Smoothie";
                            otp_selected = true;
                        } else {
                            // subscription
                            per_smoothie = jQuery(this).find(".rb-frequency-price .rb-full-price").text();

                            per_smoothie = per_smoothie.replace("$", "");
                            per_smoothie = per_smoothie.replace("USD ", "");

                            if (per_smoothie == "175.76") {
                                per_smoothie = "$2.49 per Smoothie";
                                otp_selected = false;
                            } else if (per_smoothie == "126.59") {
                                per_smoothie = "$2.69 per Smoothie";
                                otp_selected = false;
                            } else if (per_smoothie == "84.42") {
                                per_smoothie = "$2.99 per Smoothie";
                                otp_selected = false;
                            } else {
                                console.log("error, freq sub price = " + per_smoothie);
                                //per_smoothie = "";

                            }
                        }
                        jQuery(".per_smoothie_price").html(per_smoothie);

                    });
                }


                jQuery('.rb-qty-wrapper .rb-input').attr('disabled', 'disabled');




            });

        }
        else
        {
          console.log("try again on next interval");
        }

    }, 1000);
});